/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Reference_Method_Bia_GymInputs */

const en_us2_body_assessment_reference_method_bia_gym = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gym bioimpedance`)
};

const pt_br2_body_assessment_reference_method_bia_gym = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedância de academia`)
};

const es_419_body_assessment_reference_method_bia_gym = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedancia de gimnasio`)
};

const pt_pt2_body_assessment_reference_method_bia_gym = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedância de ginásio`)
};

const fr_fr2_body_assessment_reference_method_bia_gym = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impédancemétrie de salle`)
};

const de_de2_body_assessment_reference_method_bia_gym = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedanz im Studio`)
};

const it_it2_body_assessment_reference_method_bia_gym = /** @type {(inputs: Body_Assessment_Reference_Method_Bia_GymInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bioimpedenza da palestra`)
};

/**
* | output |
* | --- |
* | "Gym bioimpedance" |
*
* @param {Body_Assessment_Reference_Method_Bia_GymInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_reference_method_bia_gym = /** @type {((inputs?: Body_Assessment_Reference_Method_Bia_GymInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Reference_Method_Bia_GymInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_reference_method_bia_gym(inputs)
	if (locale === "es-419") return es_419_body_assessment_reference_method_bia_gym(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_reference_method_bia_gym(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_reference_method_bia_gym(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_reference_method_bia_gym(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_reference_method_bia_gym(inputs)
	return en_us2_body_assessment_reference_method_bia_gym(inputs)
});
export { body_assessment_reference_method_bia_gym as "body-assessment.reference_method.bia_gym" }